import(/* webpackMode: "eager" */ "/home/iktravels/domains/website/src/app/login/page.tsx");
